module.exports = __webpack_public_path__ + "img/p4.d3e7f488.png";